import { useContext } from 'react';
import { OrganizationsContext } from '~/context/organizations';

function useOrganizations() {
  const context = useContext(OrganizationsContext);
  if (context === undefined) {
    throw new Error('useOrganizations must be used within a OrganizationsProvider');
  }

  return context;
}

export default useOrganizations;
